import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

import { getStatusColor, getBackgroundTheme } from '../../../style';
import breakpoints from '../../../theme/material/breakpoints';
import { FONT_FAMILIES } from '../../../theme/material/constants';
import { CustomStyledProps } from 'style/style';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const NotificationCount = styled('span')(() => ({
  position: 'absolute',
  left: '50%', //offset by padding
  top: -4,
  fontSize: 11,
  color: '#fff',
  backgroundColor: getStatusColor().notification,
  lineHeight: '14px',
  minWidth: 14,
  textAlign: 'center',
  borderRadius: 17,
  padding: '4px 7px',
  fontWeight: 500,
  fontFamily: FONT_FAMILIES.primary,
}));

const NavLink = styled(Link)(
  {
    position: 'relative',
    padding: '10px 14px 22px 14px',
    height: 33,

    [breakpoints.down('md')]: {
      padding: '14px 4px 22px 4px',
      flexGrow: 1,
      textAlign: 'center',
    },
  },
  ({ active }: CustomStyledProps) => ({
    backgroundColor: active === 'true' ? getBackgroundTheme().navBG : 'transparent',
  })
);

const IconPlaceholder = styled('div')({
  position: 'relative',
});

interface HeaderNavLinkProps {
  to: any;
  headerRef: any;
  currentPath: any;
  activePathPattern: any;
  iconComponent: any;
  activeIconComponent: any;
  notification?: any;
}

const HeaderNavLink = ({
  to,
  headerRef,
  currentPath,
  activePathPattern,
  iconComponent,
  activeIconComponent,
  notification,
}: HeaderNavLinkProps): ReactElement => {
  let Icon;
  let isActive = false;

  if (iconComponent) {
    if (activePathPattern.test(currentPath)) {
      Icon = activeIconComponent;
      isActive = true;
    } else {
      Icon = iconComponent;
      isActive = false;
    }
  }

  return (
    <NavLink ref={headerRef} to={to} active={isActive.toString()}>
      <IconPlaceholder>
        {notification > 0 && <NotificationCount>{notification > 99 ? '99+' : notification}</NotificationCount>}
        <Icon />
      </IconPlaceholder>
    </NavLink>
  );
};

export default HeaderNavLink;
